/**
 * WordPress Dependencies
 */
import { head } from 'lodash';
import { getBlockTypes } from '@wordpress/blocks';

/**
 * Custom Dependencies
 */
import isPremium from '../utils/is-premium';

export const SUPPORTED_BLOCKS = () => {
	return getBlockTypes()
		.filter((blockType) => {
			// Filtering out the 3rd party blocks in free version.
			const isCoreBlock = blockType.name.startsWith('core/');

			if (!isCoreBlock && !isPremium()) {
				return false;
			}

			return true;
		})
		.map((blockType) => {
			const namespaceChunks = blockType.name.split('/');
			const blockNamespace = head(namespaceChunks);

			return {
				icon: blockType?.icon ?? null,
				value: blockType.name,
				rawLabel: blockType.title,
				namespace: blockNamespace,
				label: head(namespaceChunks) + ': ' + blockType.title,
			};
		});
};
